// extracted by mini-css-extract-plugin
export default {"footer_box":"Footer-module--footer_box--934ea","footer_nav":"Footer-module--footer_nav--2f4be","footer_bottom":"Footer-module--footer_bottom--70ab3"};